module.exports = __webpack_public_path__ + "img/product-supply-chain-financing.2ecc7006.jpeg";